export default __webpack_public_path__ + "static/blessed2-min-64cc84823b30868e3539429e70ac353c.png";